angular.module('rental')
    .component('rentalAgreementPaymentRegistry', {
        bindings: {
            entityId: '<',
            disabled: '<'
        },
        templateUrl: 'app/rental/agreement/payment-registry-show.html',
        controller: function ($scope, modals, RentalAgreementPaymentRegistry, InvoiceService, RentalAgreementPaymentRegistryService) {
            this.$onChanges = () => {
                RentalAgreementPaymentRegistry.get({id: this.entityId}).$promise.then(result => {
                    this.item = result
                    this.calculateTotal()
                }).catch(() => {
                    this.item = {
                        items: []
                    }
                    this.calculateTotal()
                })
            }

            this.edit = () => {
                RentalAgreementPaymentRegistryService.edit(this.entityId).then(() => this.$onChanges())
            }

            this.calculateTotal = () => {
                let totalAmount = InvoiceService.sumDecimal(this.item.items.map(item => item.amount));
                let totalAmountIN = InvoiceService.sumDecimal(this.item.items.map(item => item.amount).filter(item => item > 0));
                let totalAmountOUT = InvoiceService.sumDecimal(this.item.items.map(item => item.amount).filter(item => item < 0));
                this.total = {
                    amount: totalAmount,
                    amountIN: totalAmountIN,
                    amountOUT: totalAmountOUT,
                }
            }
        }
    })
